import css from "./MicSourceSelector.sass?inline"
import {createElement} from "@opendaw/lib-jsx"
import {Html} from "@opendaw/lib-dom"
import {isDefined, Lifecycle, Option} from "@opendaw/lib-std"
import {AudioDevices, DeviceLatency, MicSource} from "@opendaw/studio-core"
import {IconSymbol} from "@opendaw/studio-enums"
import {Surface} from "@/ui/surface/Surface"
import {Dialog} from "@/ui/components/Dialog"
import {Icon} from "@/ui/components/Icon"
import {TextTooltip} from "@/ui/surface/TextTooltip"

const className = Html.adoptStyleSheet(css, "MicSourceSelector")

type Construct = {
    lifecycle: Lifecycle
}

export const MicSourceSelector = ({lifecycle}: Construct) => {
    const label: HTMLElement = (<div className="label"/>)
    const element: HTMLElement = (
        <div className={className}>
            <Icon symbol={IconSymbol.Microphone}/>
            {label}
        </div>
    )
    const updateLabel = () => {
        label.textContent = MicSource.label()
        const deviceId = MicSource.resolveDevice()?.deviceId
        const isCalibrated = isDefined(deviceId) && isDefined(DeviceLatency.load(deviceId))
        element.classList.toggle("uncalibrated", !isCalibrated)
    }
    lifecycle.ownAll(
        TextTooltip.default(element, () => {
            const deviceId = MicSource.resolveDevice()?.deviceId
            const calibrated = isDefined(deviceId) && isDefined(DeviceLatency.load(deviceId))
            return calibrated
                ? `Microphone: ${MicSource.label()}`
                : `Microphone: ${MicSource.label()} (not calibrated)`
        }),
        MicSource.deviceId.catchupAndSubscribe(updateLabel)
    )
    AudioDevices.updateInputList().then(updateLabel)
    element.onpointerdown = (event: PointerEvent) => {
        event.preventDefault()
        event.stopPropagation()
        const body: HTMLElement = <div style={{padding: "1em 0", minWidth: "18rem"}}/>
        const renderBody = (inputs: ReadonlyArray<MediaDeviceInfo>) => {
            while (body.firstChild) {body.removeChild(body.firstChild)}
            inputs.map(device => (
                <div style={{cursor: "pointer", padding: "0.25em 0"}}
                     onclick={() => {
                         MicSource.deviceId.wrapOption(Option.wrap(device.deviceId))
                         dialog.close()
                     }}>
                    {MicSource.resolveDevice()?.deviceId === device.deviceId ? "● " : ""}{device.label}
                </div>
            )).forEach(el => body.appendChild(el))
        }
        const dialog: HTMLDialogElement = (
            <Dialog headline="Select Microphone"
                    icon={IconSymbol.Microphone}
                    cancelable={true}
                    buttons={[{text: "Cancel", primary: false, onClick: handler => handler.close()}]}>
                {body}
            </Dialog>
        )
        if (AudioDevices.inputs.length === 0) {
            body.appendChild(<p style={{color: "var(--color-shadow)"}}>Aan het wachten op toestemming…</p>)
            AudioDevices.requestPermission().then(() => { updateLabel(); renderBody(AudioDevices.inputs) })
        } else {
            renderBody(AudioDevices.inputs)
        }
        Surface.get().body.appendChild(dialog)
        dialog.showModal()
    }
    return element
}
